import { render } from "./Taxes.vue?vue&type=template&id=75563c54&scoped=true"
import script from "./Taxes.vue?vue&type=script&lang=js"
export * from "./Taxes.vue?vue&type=script&lang=js"

import "./Taxes.vue?vue&type=style&index=0&id=75563c54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75563c54"]])

export default __exports__